import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'

import { ConsumerProps } from './types'

function FormBuilderSettingsGeneralFormConsumer({ children }: ConsumerProps) {
  const {
    autoSignOffEnabled,
    elationPdfNonFax,
    formDownloadable,
    formReportType,
    internalForm,
    measuresEnabledForm,
    setAutoSignOffEnabled,
    setElationPdfNonFax,
    setFormDownloadable,
    setFormReportType,
    setInternalForm,
    setMeasuresEnabledForm,
    setIsDirty,
  } = React.useContext(FormBuilderContext)

  return children({
    autoSignOffEnabled,
    elationPdfNonFax,
    formDownloadable,
    formReportType,
    internalForm,
    measuresEnabledForm,
    setAutoSignOffEnabled,
    setElationPdfNonFax,
    setFormDownloadable,
    setFormReportType,
    setInternalForm,
    setMeasuresEnabledForm,
    setIsDirty,
  })
}

export default FormBuilderSettingsGeneralFormConsumer
